/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationships/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Relationships({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/SearchForPhone/Content/Content/Person/Relationships",
  onChange
  
}) {
let relationshipsValueData = fromData.useDataValue({ viewPath,
context: 'relationships',
})
let personTypeValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'type',
})
let personTypeChangeData = fromData.useDataChange({ viewPath,
context: 'person',
path: 'type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={180}
 data="relationships"
 from={relationshipsValueData}
 data="person.type"
 value={personTypeValueData}
 onChange={personTypeChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}